// extracted by mini-css-extract-plugin
export default {"exclusion":"Exclusion_exclusion__ficbE","exclusion__content":"Exclusion_exclusion__content__ylg4x"};